(function () {
  'use strict';

  const afterFinderOpens = (trigger, callback) => {
    if (window.DuvarkaplaAITools) {
      window.DuvarkaplaAITools.open('finder', trigger).then((finder) => {
        if (finder) callback(finder);
      });
      return;
    }
    window.requestAnimationFrame(() => {
      const finder = window.duvarkaplaWallpaperFinder;
      if (finder) {
        callback(finder);
        return;
      }
      const root = window.Shopify?.routes?.root || '/';
      window.location.assign(`${root}collections/all`);
    });
  };

  const launchFinderText = (trigger, query) => {
    trigger.dataset.wallpaperFinderPlacement ||= 'finder_landing';
    afterFinderOpens(trigger, (finder) => {
      finder.setMode('text');
      finder.query.value = String(query || '').trim();
      if (finder.query.value.length >= 3) finder.textForm.requestSubmit();
      else finder.query.focus();
    });
  };

  document.querySelectorAll('[data-ai-finder-launch-form]').forEach((form) => {
    const input = form.querySelector('[data-ai-finder-launch-query]');
    const trigger = form.querySelector('[data-wallpaper-finder-open]');
    if (!input || !trigger) return;
    form.addEventListener('submit', (event) => {
      event.preventDefault();
      launchFinderText(trigger, input.value);
    });
  });

  document.querySelectorAll('[data-ai-finder-example]').forEach((trigger) => {
    trigger.addEventListener('click', () => launchFinderText(trigger, trigger.dataset.aiFinderExample));
  });

  document.querySelectorAll('[data-ai-finder-room-open]').forEach((trigger) => {
    trigger.addEventListener('click', () => {
      trigger.dataset.wallpaperFinderPlacement ||= 'finder_landing_room';
      afterFinderOpens(trigger, (finder) => finder.setMode('room'));
    });
  });

  document.querySelectorAll('[data-ai-tool-compare]').forEach((compare) => {
    const range = compare.querySelector('input[type="range"]');
    if (!range) return;
    const update = () => compare.style.setProperty('--compare-position', `${range.value}%`);
    range.addEventListener('input', update);
    update();
  });
})();
